import { gql } from '@apollo/client';
import { VerifyAuthCodeDocument, VerifyAuthCodeQuery, VerifyAuthCodeQueryVariables } from './useVerifyAuthCode.generated';
import { useLazyQuery } from '@apollo/client';


const useVerifyAuthCode = () => {
  const [verifyAuthCode, { called, data, loading }] = useLazyQuery<VerifyAuthCodeQuery, VerifyAuthCodeQueryVariables>(VerifyAuthCodeDocument);

  return { verifyAuthCode, called, data, loading };
};

export default useVerifyAuthCode;

gql`
  query VerifyAuthCode($input: VerifyAuthCodeInput!) {
    verifyAuthCode(input: $input) {
      isVerified
      __typename
    }
  }
`;
